import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SearchDocumentsService } from '../service/search.service';
import * as SearchDocumentsActions from './search.actions';
import { catchError, filter, map, of, switchMap, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import { TrackingService } from '@schueco/angular-tracking';
import { selectSearchDocumentsLastRequest } from './search.selectors';

@Injectable()
export class SearchDocumentsEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private searchDocumentsService = inject(SearchDocumentsService);
  private trackingService = inject(TrackingService);

  repeatLastSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SearchDocumentsActions.repeatLastSearch),
      withLatestFrom(this.store.select(selectSearchDocumentsLastRequest)),
      map(([, lastRequest]) => lastRequest),
      filter((lastRequest): lastRequest is SearchDocumentsActions.SearchDocumentsRequest => lastRequest !== null),
      map((lastRequest) => SearchDocumentsActions.searchDocuments(lastRequest)),
    ),
  );

  getDocuments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SearchDocumentsActions.searchDocuments),
      switchMap((action) => {
        this.trackingService.trackSearch(action.searchTerm || '');

        return this.searchDocumentsService
          .searchDocuments(
            action.categoryId,
            action.language,
            action.filterIds,
            action.searchTerm,
            action.limit,
            action.page,
            action.searchType,
            action.sort,
            action.collectionId,
            action.documentType,
          )
          .pipe(
            map((_response) => {
              return SearchDocumentsActions.loadDocumentsSuccess({ data: _response });
            }),
            catchError((error) => {
              return of(SearchDocumentsActions.loadDocumentsFailure({ error }));
            }),
          );
      }),
    ),
  );
}
